import { ELEMENT_SELECTION_PATTERN } from '@/lib/element-selection';
import { parseResponseAnnotatedPrompt, type ResponseAnnotation } from '@/lib/response-annotations';

export type ElementSelectionContent = {
  annotations: readonly ResponseAnnotation[];
  selections: readonly string[];
  visibleText: string;
};

/**
 * Split an assistant/user text part into the pieces the desktop message view
 * renders separately: the human-readable prose, any `<element-selection>`
 * blocks, response annotations,. All of the
 * regex-driven stripping lives here so the presentational component only maps
 * the derived structure to markup.
 */
export function parseElementSelectionText(text: string): ElementSelectionContent {
  const annotatedPrompt = parseResponseAnnotatedPrompt(text);
  const selections = annotatedPrompt.request.match(ELEMENT_SELECTION_PATTERN) ?? [];
  const visibleText = annotatedPrompt.request.replace(ELEMENT_SELECTION_PATTERN, '').trim();

  return {
    annotations: annotatedPrompt.annotations,
    selections,
    visibleText,
  };
}
